import "./index.css"

import { isRTL } from "utils/constants"

import App from "./App"
import { renderWithRTL } from "./utils/renderWithRTL"

renderWithRTL(<App />, isRTL)
